import type { Union } from "./type-utils";

export const DefaultDocumentSetName = "Standard";
export const QuarterSummaryDocumentSetTypeNames = ["CurrentMonth", "CurrentMonth-1", "CurrentMonth-2"] as const;
export const ThreeMonthDocumentSetTypeNames = ["Month1", "Month2", "Month3"] as const;
export const ContractDocumentSetTypeNames = ["SignedByAllParties", "SignedByOneParty", "Unsigned"] as const;
export const RecognitionPathDocumentSetTypeNames = ["CurrentRecognitionPath", "AlternativeRecognitionPath"] as const;
export const RecognitionPathContractDocumentSetTypeNames = [
  "SignedByAllPartiesCurrentRecognitionPath",
  "SignedByOnePartyCurrentRecognitionPath",
  "UnsignedCurrentRecognitionPath",
  "SignedByAllPartiesAlternativeRecognitionPath",
  "SignedByOnePartyAlternativeRecognitionPath",
  "UnsignedAlternativeRecognitionPath",
] as const;

export const DocumentSetTypeNames = [
  ...ContractDocumentSetTypeNames,
  ...RecognitionPathDocumentSetTypeNames,
  ...RecognitionPathContractDocumentSetTypeNames,
  ...QuarterSummaryDocumentSetTypeNames,
  ...ThreeMonthDocumentSetTypeNames,
] as const;

export type ContractDocumentSetType = Union<typeof ContractDocumentSetTypeNames>;
export type RecognitionPathDocumentSetType = Union<typeof RecognitionPathDocumentSetTypeNames>;
export type RecognitionPathContractDocumentSetType = Union<typeof RecognitionPathContractDocumentSetTypeNames>;

export type DocumentSetType = Union<typeof DocumentSetTypeNames>;
export type DocumentSetTypes = Readonly<[DocumentSetType, ...DocumentSetType[]]>;

export interface DocumentSetGroup {
  name: string;
  sets: DocumentSetTypes;
}

export type DocumentSetGroupArray = [DocumentSetGroup, DocumentSetGroup, ...DocumentSetGroup[]];
